import { handleActions } from 'redux-actions';
import { fromJS, List, Map } from 'immutable';
import {
  startLoading,
  endLoading,
  fetchUser,
  fetchSettings,
  fetchEvents,
  updateSettings,
  updateSettingsProp,
  fetchOrganizers,
} from '../actions/component_actions';

const initialState = Map({
  loading: true,
  settings: Map(),
  events: List(),
  user: Map(),
  organizers: List(),
});

const componentReducers = handleActions(
  {
    [startLoading]: state => state.set('loading', true),
    [endLoading]: state => state.set('loading', false),
    [updateSettings]: (state, { payload }) => state.set('settings', payload),
    [updateSettingsProp]: (state, { payload: { key, value } }) =>
      state.setIn(['settings', key], fromJS(value)),
    [fetchSettings]: (state, { payload }) => state.set('settings', fromJS(payload)),
    [fetchEvents]: (state, { payload }) => state.set('events', fromJS(payload)),
    [fetchUser]: (state, { payload }) => state.set('user', fromJS(payload)),
    [fetchOrganizers]: (state, { payload }) => state.set('organizers', fromJS(payload)),
  },
  initialState
);

export default componentReducers;



// WEBPACK FOOTER //
// ./src/reducers/component_reducers.js